<template>
  <div id="app">
    <nav class="bg-white shadow-lg sticky top-0 z-50">
      <div class="container-max">
        <div class="flex justify-between items-center py-4">
          <!-- Logo -->
          <router-link to="/" class="flex items-center space-x-3">
            <img src="/Qup.svg" alt="Qup Teknoloji Logo" class="h-10 w-auto" />
            <span class="text-xl font-bold text-qup-dark">Qup Teknoloji</span>
          </router-link>
          
          <!-- Desktop Navigation -->
          <div class="hidden md:flex items-center space-x-8">
            <router-link 
              to="/" 
              class="text-gray-700 hover:text-qup-blue transition-colors duration-200"
              active-class="text-qup-blue font-semibold"
            >
              Home
            </router-link>
            <router-link 
              to="/services" 
              class="text-gray-700 hover:text-qup-blue transition-colors duration-200"
              active-class="text-qup-blue font-semibold"
            >
              Services
            </router-link>
            <router-link 
              to="/products" 
              class="text-gray-700 hover:text-qup-blue transition-colors duration-200"
              active-class="text-qup-blue font-semibold"
            >
              Products
            </router-link>
            <router-link 
              to="/contact" 
              class="text-gray-700 hover:text-qup-blue transition-colors duration-200"
              active-class="text-qup-blue font-semibold"
            >
              Contact
            </router-link>
          </div>
          
          <!-- Mobile menu button -->
          <div class="md:hidden flex items-center space-x-4">
            <button 
              @click="toggleMobileMenu" 
              class="text-gray-700 hover:text-qup-blue focus:outline-none focus:ring-2 focus:ring-qup-blue rounded"
            >
              <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path v-if="!mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        
        <!-- Mobile Navigation -->
        <div v-if="mobileMenuOpen" class="md:hidden pb-4">
          <div class="flex flex-col space-y-2">
            <router-link 
              to="/" 
              @click="mobileMenuOpen = false"
              class="text-gray-700 hover:text-qup-blue transition-colors duration-200 py-2"
              active-class="text-qup-blue font-semibold"
            >
              Home
            </router-link>
            <router-link 
              to="/services" 
              @click="mobileMenuOpen = false"
              class="text-gray-700 hover:text-qup-blue transition-colors duration-200 py-2"
              active-class="text-qup-blue font-semibold"
            >
              Services
            </router-link>
            <router-link 
              to="/products" 
              @click="mobileMenuOpen = false"
              class="text-gray-700 hover:text-qup-blue transition-colors duration-200 py-2"
              active-class="text-qup-blue font-semibold"
            >
              Products
            </router-link>
            <router-link 
              to="/contact" 
              @click="mobileMenuOpen = false"
              class="text-gray-700 hover:text-qup-blue transition-colors duration-200 py-2"
              active-class="text-qup-blue font-semibold"
            >
              Contact
            </router-link>
          </div>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <main>
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="bg-qup-dark text-white">
      <div class="container-max section-padding">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div class="col-span-1 md:col-span-2">
            <div class="flex items-center space-x-3 mb-4">
              <img src="/Qup.svg" alt="Qup Teknoloji Logo" class="h-8 w-auto brightness-0 invert" />
              <span class="text-lg font-bold">Qup Teknoloji</span>
            </div>
            <p class="text-gray-300 mb-4">
              Transforming businesses through innovative technology solutions. Expert IT Risk & Security Consultancy, Process Optimization, and Software Development services.
            </p>
          </div>
          
          <div>
            <h3 class="font-semibold mb-4">Services</h3>
            <ul class="space-y-2 text-gray-300">
              <li>IT Risk & Security</li>
              <li>Process Optimization</li>
              <li>Software Development</li>
              <li>System Integration</li>
            </ul>
          </div>
          
          <div>
            <h3 class="font-semibold mb-4">Contact</h3>
            <ul class="space-y-2 text-gray-300">
              <li>
                Nidakule Ataşehir<br>
                Barbaros Mah. Begonya Sk. No:1<br>
                Ataşehir, Istanbul, Turkey
              </li>
              <li>info@quptechnology.com</li>
              <li>+90 535 107 83 21</li>
            </ul>
          </div>
        </div>
        
        <div class="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
          <p>© {{ currentYear }} Qup Teknoloji Anonim Şirketi. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

const mobileMenuOpen = ref(false)

const currentYear = computed(() => new Date().getFullYear())

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}
</script>
